import * as Select from '@radix-ui/react-select';
import { useTranslation } from 'react-i18next';

import { DROPDOWN_CLEAR_SENTINEL_VALUE } from '~/chords/DropdownSingleSelect/constants';
import { Icon } from '~/chords/Icon';
import { cn } from '~/chords/lib/cn';

export function DropdownClearItem() {
  const { t } = useTranslation('common');

  return (
    <div className="border-b border-emphasis-subtle">
      <Select.Item
        value={DROPDOWN_CLEAR_SENTINEL_VALUE}
        className={cn(
          'flex min-h-[36px] w-full cursor-pointer items-center gap-sm px-md text-body-sm text-default',
          'transition-colors duration-300 hover:bg-emphasis-strong focus:outline-none focus:bg-emphasis-strong',
        )}
        asChild
      >
        <div>
          {/*
            Mirror IconButton size="small" chrome (28x28 round hover background)
            so the X gets a circle on hover, matching the trigger overlay clear
            button. Uses bg-emphasis-stronger so the circle remains visible on
            top of the row's bg-emphasis-strong hover/focus background.
          */}
          <span className="flex size-[1.75rem] items-center justify-center rounded-full p-xs transition-colors duration-200 hover:bg-emphasis-stronger">
            <Icon size="sm" type="xmark" aria-hidden />
          </span>
          <Select.ItemText>{t('dropdownTree.clearSelection')}</Select.ItemText>
        </div>
      </Select.Item>
    </div>
  );
}

DropdownClearItem.displayName = 'DropdownClearItem';
